import { createServerFn } from '@tanstack/react-start'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import z from 'zod'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
export const envsEnums = z.enum(['STARTER_PRODUCT_ID', 'PRO_PRODUCT_ID'])
export const getEnvServer = createServerFn().inputValidator(envsEnums).handler(({ data }) => {
  const value = process.env[data]
  if (!value) {
    throw new Error(`Missing environment variable: ${data}`)
  }
  return value
})
